<template>
  <div class="card-normal text-xs-center">
    <div v-if="carregando" class="carregando"><i class="el-icon-loading"></i></div>
    <div :class="carregando ? 'blur' : ''">
      <div class="card-content">
        <div class="avatar">
          <span class="avatar-ini" style="left:1px"><i class="far fa-clock"></i></span>
        </div>
        <h2>Horas por Mês</h2>
        <h3>{{dia.format('MMMM')}}</h3>

        <div v-if="!hist_horas.length">
          <h4>Nenhum colaborador bateu ponto esse mês.</h4>
        </div>
        <div v-else v-for="(item, index) in hist_horas" :key="index" @click="$router.push(`colaborador/${item.uid}`)" class="horas click">
          <p class="colaborador">{{item.colaborador.replace(/(([^\s]+\s\s*){3})(.*)/,"$1")}}</p>
          <p class="horasColab">{{`${parseInt(item.minutos / 60)}h ${('0' + (item.minutos % 60)).slice(-2)}m`}}</p>
          <p class="horas-extras" :class="(item.minutos_extras >= 0) ? 'extra' : 'falta'">
            {{(item.minutos_extras >= 0) ? 'Horas extras' : 'Devendo'}}: {{ item.horas_extras }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { calculaHorasMes } from '../../config/functions';

export default {
  data: () => ({
    carregando: true,
    hist_horas: [],
    dia: moment()
  }),
  created() {
    calculaHorasMes(this.dia).then(horas => {
      this.hist_horas = horas;
      this.carregando = false;
    });
  }
};
</script>
